export default {
  main: '#1B4119',
  secondary: '#D09B0F',
  contrastingColor: '#ffffff',
  priceColor: '#D09B0F',
  entryBackground: '#1B4119',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
